module.exports = __webpack_public_path__ + "img/Weapon_67.4cc65f78.png";